// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"76e2e956","450":"01db73a6","453":"2b769790","674":"52c57e67"}[chunkId] + ".chunk.js";
};